import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { PublicTransparencyPage } from './Public';
import { ProtectedTransparencyView } from './Protected';

/**
 * Transparency Center Route Wrapper
 *
 * Routes:
 * - /transparency/:companyKey (no token) -> Public Transparency Page
 * - /transparency/:companyKey?token=xxx -> Protected view for external viewers
 *
 * The component detects the presence of a token query param to determine
 * which view to render.
 */
export const TransparencyPage = () => {
  const { companyKey } = useParams();
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get('token');

  // If token is provided, show protected view for external viewers
  if (accessToken) {
    return (
      <ProtectedTransparencyView
        companyKey={companyKey}
        accessToken={accessToken}
        isExternalViewer={true}
      />
    );
  }

  // No token = public transparency page
  return <PublicTransparencyPage companyKey={companyKey} />;
};

export { PublicTransparencyPage } from './Public';
export { ProtectedTransparencyView } from './Protected';
